/**
 * Stacked From → To route: location primary, department secondary.
 */

import React from 'react';
import './TransferRouteStack.css';

const TransferRouteStack = ({
  fromLocation,
  toLocation,
  fromDepartment,
  toDepartment,
  compact = false,
  className = '',
}) => {
  const fromLoc = fromLocation || '—';
  const toLoc = toLocation || '—';
  const fromDept = fromDepartment || '—';
  const toDept = toDepartment || '—';

  return (
    <div
      className={`transfer-route-stack${compact ? ' transfer-route-stack--compact' : ''} ${className}`.trim()}
    >
      <div className="transfer-route-endpoint">
        <div className="transfer-route-location">{fromLoc}</div>
        <div className="transfer-route-department">{fromDept}</div>
      </div>
      <span className="transfer-route-arrow" aria-hidden="true">
        →
      </span>
      <div className="transfer-route-endpoint">
        <div className="transfer-route-location">{toLoc}</div>
        <div className="transfer-route-department">{toDept}</div>
      </div>
    </div>
  );
};

export default TransferRouteStack;
